import {
  GA_ACT_STREAMED_EPISODE_START,
  GA_ACT_STREAMED_EPISODE,
  GA_ACT_STREAMED_GENRE_START,
  GA_ACT_STREAMED_GENRE,
  GA_ACT_USER_SEEKED_AUDIO,
  GA_ACT_STREAMED_TRACK
} from '@/config/events-ga/actions';
import { GA_CAT_AUDIO_STREAMING } from '@/config/events-ga/categories';
import {
  GA_DIM_EPISODE_ID,
  GA_DIM_EPISODE_NUMBER,
  GA_DIM_EPISODE_SEASON_NUMBER,
  GA_DIM_GENRES,
  GA_DIM_SHOW_ID,
  GA_DIM_SHOW_TITLE,
  GA_DIM_GENRE_ID,
  GA_DIM_GENRE_TITLE,
  GA_DIM_GENRE_PARENT_TITLE,
  GA_DIM_GENRE_PARENT_ID,
  GA_DIM_SEEK_DIRECTION,
  GA_DIM_TRACK_ARTIST,
  GA_DIM_TRACK_TITLE
} from '@/config/events-ga/dimensions';
import {
  GA_MET_PERCENTAGE_PROGRESS,
  GA_MET_TOTAL_LISTENING_TIME,
  GA_MET_SKIPPED_TIME,
  GA_MET_START_POSITION,
  GA_MET_END_POSITION,
  GA_MET_SNAPPED_TO_POSITION
} from '@/config/events-ga/metrics';

export const GAstreamedEpisodeStart = ({
  episodeId,
  episodeNumber,
  seasonNumber,
  showId,
  showTitle,
  genres
} = {}) => ({
  eventCategory: GA_CAT_AUDIO_STREAMING,
  eventAction: GA_ACT_STREAMED_EPISODE_START,
  dimensions: {
    [GA_DIM_EPISODE_ID]: episodeId,
    [GA_DIM_EPISODE_NUMBER]: episodeNumber,
    [GA_DIM_EPISODE_SEASON_NUMBER]: seasonNumber,
    [GA_DIM_SHOW_ID]: showId,
    [GA_DIM_SHOW_TITLE]: showTitle,
    [GA_DIM_GENRES]: genres
  }
});

export const GAstreamedEpisode = ({
  episodeId,
  episodeNumber,
  seasonNumber,
  showId,
  showTitle,
  genres,
  percentageProgress,
  totalListeningTimeSeconds
} = {}) => ({
  eventCategory: GA_CAT_AUDIO_STREAMING,
  eventAction: GA_ACT_STREAMED_EPISODE,
  dimensions: {
    [GA_DIM_EPISODE_ID]: episodeId,
    [GA_DIM_EPISODE_NUMBER]: episodeNumber,
    [GA_DIM_EPISODE_SEASON_NUMBER]: seasonNumber,
    [GA_DIM_SHOW_ID]: showId,
    [GA_DIM_SHOW_TITLE]: showTitle,
    [GA_DIM_GENRES]: genres
  },
  metrics: {
    [GA_MET_PERCENTAGE_PROGRESS]: percentageProgress,
    [GA_MET_TOTAL_LISTENING_TIME]: totalListeningTimeSeconds
  }
});

export const GAstreamedGenreStart = ({
  genreId,
  genreTitle,
  parentGenreId,
  parentGenreTitle
} = {}) => ({
  eventCategory: GA_CAT_AUDIO_STREAMING,
  eventAction: GA_ACT_STREAMED_GENRE_START,
  dimensions: {
    [GA_DIM_GENRE_ID]: genreId,
    [GA_DIM_GENRE_TITLE]: genreTitle,
    [GA_DIM_GENRE_PARENT_ID]: parentGenreId,
    [GA_DIM_GENRE_PARENT_TITLE]: parentGenreTitle
  }
});

export const GAstreamedGenre = ({
  genreId,
  genreTitle,
  parentGenreId,
  parentGenreTitle,
  totalListeningTimeSeconds
} = {}) => ({
  eventCategory: GA_CAT_AUDIO_STREAMING,
  eventAction: GA_ACT_STREAMED_GENRE,
  dimensions: {
    [GA_DIM_GENRE_ID]: genreId,
    [GA_DIM_GENRE_TITLE]: genreTitle,
    [GA_DIM_GENRE_PARENT_ID]: parentGenreId,
    [GA_DIM_GENRE_PARENT_TITLE]: parentGenreTitle
  },
  metrics: { [GA_MET_TOTAL_LISTENING_TIME]: totalListeningTimeSeconds }
});

export const GAuserSeekedAudio = ({
  seekDirection,
  skippedTime,
  startPosition,
  endPosition,
  snappedToPosition
} = {}) => ({
  eventCategory: GA_CAT_AUDIO_STREAMING,
  eventAction: GA_ACT_USER_SEEKED_AUDIO,
  dimensions: { [GA_DIM_SEEK_DIRECTION]: seekDirection },
  metrics: {
    [GA_MET_SKIPPED_TIME]: skippedTime,
    [GA_MET_START_POSITION]: startPosition,
    [GA_MET_END_POSITION]: endPosition,
    [GA_MET_SNAPPED_TO_POSITION]: snappedToPosition
  }
});

export const GAstreamedTrack = ({
  episodeId,
  episodeNumber,
  seasonNumber,
  showId,
  showTitle,
  trackTitle,
  trackArtist
} = {}) => ({
  eventCategory: GA_CAT_AUDIO_STREAMING,
  eventAction: GA_ACT_STREAMED_TRACK,
  dimensions: {
    [GA_DIM_EPISODE_ID]: episodeId,
    [GA_DIM_EPISODE_NUMBER]: episodeNumber,
    [GA_DIM_EPISODE_SEASON_NUMBER]: seasonNumber,
    [GA_DIM_SHOW_ID]: showId,
    [GA_DIM_SHOW_TITLE]: showTitle,
    [GA_DIM_TRACK_ARTIST]: trackArtist,
    [GA_DIM_TRACK_TITLE]: trackTitle
  }
});